<template>
  <div class="paginacao" v-if="totalResultados > itensPorPagina">

    <div class="w3-col s12 m12 l12" style="text-align: center; margin-top: 20px;">
      <span class="w3-text w3-right-align" style="width: 100%; display: block;">
        {{ resultadosExibidosNaTela }} / {{ totalResultados }}
      </span>

      <div class="w3-bar" style="white-space: normal; margin-bottom: 20px">
        <button 
          :class="getClasseSetas(0)" 
          :disabled="paginaAtual === 0"
          @click.prevent="mudarPagina(0)">&laquo;
        </button>
        <button 
          :class="getClasseSetas(0)" 
          :disabled="paginaAtual === 0" 
          @click.prevent="mudarPagina(paginaAtual - 1)">&lsaquo;
        </button>
        <a 
          @click.prevent="mudarPagina(index)"
          v-for="(numeroDaPagina, index) in totalDePaginas"
          :key="index"
          v-show="numeroDaPagina == 0 ||
          Math.abs(numeroDaPagina - (paginaAtual + 1)) < 4" 
          :class="getClassePaginaAtiva(index)">
          {{ numeroDaPagina }}
        </a>
        <button 
          :class="getClasseSetas(totalDePaginas - 1)" 
          :disabled="paginaAtual === (totalDePaginas - 1)"
          @click.prevent="mudarPagina(paginaAtual + 1)">&rsaquo;
        </button>
        
        <button 
          :class="getClasseSetas(totalDePaginas - 1)" 
          :disabled="paginaAtual === (totalDePaginas - 1)" 
          @click.prevent="mudarPagina(totalDePaginas - 1)">&raquo;
        </button>
      </div>
    </div>
  </div><!-- paginacao -->
</template>

<script>
  export default {
    props: ['paginaAtual', 'totalDePaginas', 'totalResultados', 'itensPorPagina'],
    methods: {
      getClassePaginaAtiva(numeroDaPagina) {
        if(this.paginaAtual == numeroDaPagina) {
          return 'w3-button w3-theme';
        } else {
          return 'w3-button';
        }
      },
      getClasseSetas(numeroDaPagina) {
        if(this.paginaAtual == numeroDaPagina) {
          return 'w3-button w3-disabled';
        } else {
          return 'w3-button';
        }
      },
      mudarPagina: function(numeroDaPagina) {
        this.$emit('pagina', numeroDaPagina);
      },
    },
    computed: {
      resultadosExibidosNaTela: function() {
        if((this.paginaAtual + 1) != this.totalDePaginas) {
          return (this.paginaAtual + 1) * this.itensPorPagina;
        } else {
          return this.totalResultados;
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Paginacao.vue